<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("ratecard") }}</div>
      </div>
      <div>
        <b-button variant="default" to="add-rate-card" class="btn-blue">{{
          $tc("add")
        }}</b-button>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center justify-content-between w-100">
        <div>
          <b-form-input
            @input="onSearch"
            v-model="searchValue"
            placeholder="Search..."
          ></b-form-input>
        </div>
        <div class="mx-2">
          <FilterByStatusDropdown
            :onSelect="
              (filterIsActive) => {
                filter_is_active = filterIsActive;
                getRatecards(cinema_id, filterIsActive);
              }
            "
          />
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(ratecard, ratecardIndex) in ratecards"
        :key="ratecardIndex"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ ratecard.rc_name }}</h6>
            <p>{{ ratecard.rc_total_amount }}</p>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  v-if="ratecard.rc_is_active == 'Y'"
                  @click="goToRoute('/cinema-manager/edit-rate-card', ratecard)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/cinema-manager/view-rate-card', ratecard)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div>
              <StatusDot
                :status="
                  ratecard.rc_is_active === 'Y'
                    ? 'active'
                    : ratecard.rc_is_active === 'N' && 'inactive'
                "
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="ratecards.length == 0">
        <p>{{ $t("NoRecords") }}</p>
      </div>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-4 col-xl-3 align-self-center mb-4">
          <div class="dropdown-curve-container mr-2">
            <label
              :class="
                selectedCinema && selectedCinema.length > 0 ? 'shift-up' : ''
              "
              >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
            >
            <b-dropdown
              :disabled="isRoleID"
              :text="selectedCinema"
              name="selectcinema"
              id="selectcinema"
              variant="dropdown-curve"
              class="w-100"
            >
              <div class="px-2 pb-2">
                <input
                  required
                  autofocus
                  type="search"
                  placeholder="Search Cinema"
                  class="form-control form-control-sm"
                  v-on:keyup="onSearchCinema($event.target.value)"
                  v-on:keydown="onSearchCinema($event.target.value)"
                  v-model="searchCinema"
                />
              </div>
              <b-dropdown-item
                href="#"
                v-for="(Cinema, CinemaIndex) in Cinemas"
                :key="CinemaIndex"
                v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
      </div>

      <table class="list-view-table" v-if="listView">
        <thead>
          <tr>
            <th>
              <img
                v-if="this.columnName != 'rc_name'"
                @click="onSortValue('rc_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('rc_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('rc_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("ratecard") }}
            </th>
            <th class="text-center">{{ $t("netamount") }}</th>
            <th class="text-center">{{ $t("grossamount") }}</th>
            <th class="text-right">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
          </tr>
        </thead>
        <tbody v-if="ratecards.length > 0">
          <tr
            v-for="(ratecard, ratecardIndex) in ratecards"
            :key="ratecardIndex"
          >
            <td>{{ ratecard.rc_name }}</td>
            <td class="text-center">{{ ratecard.rc_net_amount.toFixed(this.MIN_FRACTION_DIGITS) }}</td>
            <td class="text-center">
              {{ ratecard.rc_total_amount.toFixed(this.MIN_FRACTION_DIGITS) }}
            </td>
            <td>
              <div class="d-flex align-items-center justify-content-end">
                <StatusDot
                  :status="
                    ratecard.rc_is_active === 'Y'
                      ? 'active'
                      : ratecard.rc_is_active === 'N' && 'inactive'
                  "
                />

                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item
                    @click="
                      goToRoute('/cinema-manager/edit-rate-card', ratecard)
                    "
                  >
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="
                      goToRoute('/cinema-manager/view-rate-card', ratecard)
                    "
                  >
                    <span class="icon-eye mr-1"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-if="ratecards.length == 0">
          <tr>
            <td colspan="4">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
      <div
        v-if="ratecards.length > 0"
        class="d-flex justify-content-end mt-4 mb-2 align-items-center"
      >
        <div>{{ $t("download") }} as :</div>
        <a
          :href="
            BASE_URL +
            `/api/admin/export_rate_card_excel?cinema_id=${cinema_id}&filter_is_active=${filter_is_active}`
          "
          target="_blank"
          title="Download as Excel"
          download
        >
          <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
        </a>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import { mapState, mapGetters, mapActions } from "vuex";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      isRoleID: true,
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      selectedCinema: "",
      cinema_id: null,
      Cinemas: [],

      isSort: false,
      isAscending: false,
      columnName: "created_at",
      orderBy: "desc",

      debounce: null,
      searchValue: "",
      searchKey: "rc_name", //the key name in your table

      checked: "N",
      ratecards: [],
      gridView: false,
      listView: true,
      CinemasCopy: [],
      searchCinema: "",
      filter_is_active: "Y",
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    this.cinema_manager_add_edit_disabled = roleid;
    if (true) {
      this.isRoleID = false;
    }

    this.getCinemaList(obj);
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.selectedCinema = CinemaObj.cine_name;
      this.getRatecards(CinemaObj.cine_id);
      this.cinema_id = CinemaObj.cine_id;
    }

    this.getviewingnumber();
  },
  mounted() {},
  methods: {
    onSortValue(columnName, orderBy) {
      if (this.selectedCinema.length == 0) {
        return this.$toasted.show("Please select cinema");
      }
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getRatecards(this.cinema_id);
    },
    onSearchCinema: function (value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemaList: function (cine_id) {
      this.Cinemas = [];
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                let cinema = {
                  cine_name: x.cine_name,
                  cine_id: x.cine_id,
                };

                this.onSelectCinema(null, cinema);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event, params) {
      this.ratecards = [];
      this.selectedCinema = params.cine_name;
      this.cinema_id = params.cine_id;
      this.getRatecards(params.cine_id);
      this.searchCinema = "";
      this.onSearchCinema(null);
      this.$store.dispatch("selectDropdownCinema", params);
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getRatecards(this.cinema_id);
      } else {
        this.currentPage = event;
        this.getRatecards(this.cinema_id);
      }
    },
    //search
    onSearch(event) {
      this.searchValue = "";
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.searchValue = event;
        this.getRatecards(this.cinema_id);
      }, 1500);
    },
    getRatecards(cine_id, filterIsActive = "Y") {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        cinema_id: cine_id,
        searchValue: this.searchValue,
        searchKey: this.searchKey,
        columnName: this.columnName,
        orderBy: this.orderBy,
        filter_is_active: filterIsActive,
      };
      this.ratecards = [];
      CinemasService.GetRatecardsList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.ratecards = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
                this.selectedvalue = this.perPage;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.rows = 0;
              this.selectedvalue = 10;
              this.ratecards = [];
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    goToRoute: function (path, { rc_id, rc_pas_setting_name }) {
      this.$router.push({
        path: path,
        query: {
          id: rc_id,
          rc_pas_setting_name: rc_pas_setting_name,
        },
      });
    },
    // OnHandler
    OnSwitchHandler: function (event, item) {
      console.log("event, item :", event, item);
    },
    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>

<style scoped>
.pvt-rate-card {
  background-color: white;
  padding: 32px 0;
}
.pvt-rate-card h2,
.pvt-rate-card h3 {
  font-weight: bold;
  color: var(--blue);
}

.pvt-rate-card-box p {
  margin: 0;
}

.pvt-rate-card .pvt-rate-card-box {
  background-color: #e6e6f8;
  /* box-shadow: 0 0 15px rgba(32, 21, 21, 0.5); */
  border-radius: 1rem;
  padding: 16px;
  /* margin-top: 16px; */
  border: 2px solid var(--blue);
  line-height: 1.2;
}

.pvt-rate-card-box > section {
  display: grid;
  grid-template-columns: repeat(4, 23%);
  grid-gap: 8px 2%;
  width: 100%;
}

.pvt-rate-card-box > section > article p:first-child {
  color: var(--blue);
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 4px;
}

.pvt-rate-card-box > section > article .movie-dropdown {
  width: 100%;
}

.pvt-rate-card-box .total-price {
  color: var(--blue);
  font-weight: bold;
  text-align: right;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/RatecardComponents/rateCard.vue